import { useEffect, useState } from 'react';

import loadJsonData from '../Utils/loadJsonData';

import URLS from '../Utils/URLs.API';
import sessionedLink from '../Utils/sessionedLinks';
import { NavLink } from 'react-router-dom';
import InputElement from '../Elements/InputElement';
import MFXLocalStorage from 'Helpers/MFXLocalStorage';
import SmallHeadline from '../Elements/SmallHeadline';
import Loading from '../Elements/Loading';
import { formatDate, getDayShort, minuteToHHMM } from 'Helpers/dateHelper';
import apiPost from '../Hooks/apiPost';
import SavedModal from '../Elements/SavedModal';
import loadJsonPost from '../Utils/jsonPost';

function MonthlyClosingView(props: any): JSX.Element {
    const [loading, setLoading] = useState(true); // eslint-disable-line
    const [list, setList] = useState(null as any);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [overtime, setOverTime] = useState(0);
    const [payout, setPayout] = useState('');
    const [text, setText] = useState('');
    const [alreadyReleased, setAlreadyReleased] = useState(false);
    const [showCashedCompensation, setShowCashedCompensation] = useState(false);
    const currentYear = new Date().getFullYear();
    const years = [currentYear - 3, currentYear - 2, currentYear - 1, currentYear, currentYear + 1];
    const [saveMessage, setSaveMessage] = useState(null as any);

    const [message, setMessage] = useState('');
    //TODO
    //load todays Appointments / Tasks
    //from - props.Listtype, today
    useEffect(() => {
        setLoading(true);
        setAlreadyReleased(false);
        loadJsonData('/' + MFXLocalStorage?.getConnectionKey() + URLS.CheckWorkingTimes + '?Data.Year=' + year + '&Data.KwMonth=' + month).then((data: any) => {
            if (data.Meta.Success && data.Data) {
                console.log(data);
                setList(data.Data.WorkingTimeViolations);
                setAlreadyReleased(data.Data.IsReleased);
            } else {
                setList(null);
                setMessage(data?.Meta?.ErrorMessages?.[0]?.Message || 'Fehler beim Laden der Daten');
            }
            setLoading(false);
        });
        var username = MFXLocalStorage.getData('UserName');

        loadJsonData('/' + MFXLocalStorage.getConnectionKey() + URLS.GetTimeRecordingSummary + '?Data.TargetUser=' + username + '&Data.WorkingUser=' + username + '&Data.Year=' + year + '&Data.KwMonth=' + month).then((data: any) => {
            if (data?.Data?.TimeRecordingSummaryData) {
                setOverTime(data.Data.TimeRecordingSummaryData.SummeUebertragZeitraum);
            }
        });
    }, [year, month]);

    function timeToMinutes(str) {
        if (str === null || str === undefined || str === '') return 0;
        if (!/^[0-9:]+$/.test(str)) return -1;

        let parts = str.split(':');

        if (parts.length === 1) {
            return parseInt(parts[0], 10) * 60;
        }

        if (parts.length === 2) {
            let hours = parseInt(parts[0], 10);
            let minutes = parseInt(parts[1], 10);

            if (isNaN(hours) || isNaN(minutes) || minutes >= 60) return -1;

            return hours * 60 + minutes;
        }

        return -1;
    }
    function saveCompensation() {
        console.log('save compensation ' + payout + ' ' + text);
        var minutes = timeToMinutes(payout);
        if (minutes < 0) {
            alert('Bitte Stunden im Format hh:mm eingeben');
            return;
        }
        loadJsonPost('/' + MFXLocalStorage?.getConnectionKey() + URLS.SaveCashedCompensatoryTime, { Data: { Year: year, KwMonth: month, CashedTime: minutes, AdditionalText: text } }).then((data: any) => {
            console.log(data);
            if (data.Meta.Success) {
                setSaveMessage({ success: true, message: window.Dictionary.getTranslation(14233) });
            } else setSaveMessage({ success: false, message: data?.Meta?.ErrorMessages?.[0]?.Message || 'Fehler beim Speichern der Daten' });
        });
    }
    console.log(list);
    return (
        <div className="mfx-view">
            {props.children}
            {!showCashedCompensation && (
                <>
                    <h2>{window.Dictionary.getTranslation(14293)} </h2>
                    <div className="time-recording">
                        <div className="time-recording-row">
                            <div>
                                <div>
                                    <label>{window.Dictionary.getTranslation(3698)}</label>
                                    <select value={year} onChange={(e: any) => setYear(e.target.value)}>
                                        {years?.map((y: any) => (
                                            <option value={y}>{y}</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label>{window.Dictionary.getTranslation(3699)}</label>
                                    <select value={month} onChange={(e: any) => setMonth(e.target.value)}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {loading && <Loading title="ListView" />}
            {!loading && list && list.length > 0 && !showCashedCompensation && !alreadyReleased && (
                <>
                    <div className="mfx-table-container">
                        <table className="mfx-table" style={{ minWidth: 'unset' }}>
                            <tr>
                                <th>{window.Dictionary.getTranslation(4253)}</th>
                                <th>{window.Dictionary.getTranslation(7)}</th>
                                <th>{window.Dictionary.getTranslation(1250)}</th>
                                <th>{window.Dictionary.getTranslation(1252)}</th>
                                <th>{window.Dictionary.getTranslation(1412)}</th>
                            </tr>
                            {list.map((listitem: any, idx: any) => {
                                return (
                                    <tr key={idx}>
                                        <td>{getDayShort(listitem.Date)}.</td>
                                        <td>{formatDate(new Date(listitem.Date), 'Date')}</td>
                                        <td>{minuteToHHMM(listitem.TargetWorkingTime)}</td>
                                        <td style={{ color: listitem.ViolationDescription === 'Keine Arbeitszeit erfasst' ? '#f00' : '#ffa500' }}>{minuteToHHMM(listitem.ActualWorkingTime)}</td>
                                        <td>{listitem.ViolationDescription?.length > 80 ? listitem.ViolationDescription?.substr(0, 80) + '...' : listitem.ViolationDescription}</td>
                                    </tr>
                                );
                            })}
                        </table>
                    </div>
                    <button
                        onClick={() => {
                            if (overtime > 0) setShowCashedCompensation(true);
                            else saveCompensation();
                        }}>
                        {overtime > 0 ? window.Dictionary.getTranslation(11869) : window.Dictionary.getTranslation(17497)}
                    </button>
                </>
            )}

            {!loading && list && list <= 0 && !alreadyReleased && (
                <h4 className="nothing-found">
                    <div className="success-false extra-small">
                        <div className="icon-style-arrow">
                            <i className="icon-close"></i>
                        </div>
                    </div>
                    {window.Dictionary.getTranslation(14259)}
                </h4>
            )}
            {alreadyReleased && !loading && (
                <h2 className="error-message" style={{ color: 'var(--successColor)' }}>
                    {window.Dictionary.getTranslation(17496)}
                </h2>
            )}
            {!loading && !list && (
                <h2 className="error-message" style={{ color: 'var(--errorColor)' }}>
                    {window.Dictionary.getTranslation(message)}
                </h2>
            )}
            {showCashedCompensation && (
                <div className="cashed-compensation-container">
                    <div className="cashed-compensation-row">
                        <label>{window.Dictionary.getTranslation(6065)}</label>
                        <input disabled={true} type="text" value={minuteToHHMM(overtime)} />
                    </div>

                    <div className="cashed-compensation-row">
                        <label>{window.Dictionary.getTranslation(6065)}</label>
                        <input type="text" onChange={e => setPayout(e.target.value)} value={payout} />
                    </div>

                    <button className="set-payout-button" onClick={() => setPayout(minuteToHHMM(overtime))}>
                        {window.Dictionary.getTranslation(6066)}
                    </button>

                    <label className="textarea-label">{window.Dictionary.getTranslation(6321)}</label>
                    <textarea onChange={e => setText(e.target.value)}></textarea>
                    <button onClick={() => saveCompensation()}>{window.Dictionary.getTranslation(17497)}</button>
                </div>
            )}
            {saveMessage && (
                <SavedModal
                    saveMessage={saveMessage}
                    closeIcon={true}
                    handleClose={() => {
                        props.onClose();
                    }}
                    modalButtons={[]}
                />
            )}
        </div>
    );
}

export default MonthlyClosingView;
